Object.defineProperty(exports,"__esModule",{value:true});var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);

var _d3Shape=require("d3-shape");var d3Shape=_interopRequireWildcard(_d3Shape);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Area=function(_React$Component){_inherits(Area,_React$Component);function Area(){_classCallCheck(this,Area);return _possibleConstructorReturn(this,(Area.__proto__||Object.getPrototypeOf(Area)).apply(this,arguments));}_createClass(Area,[{key:"toNewName",value:function toNewName(













interpolation){

var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
return"curve"+capitalize(interpolation);
}},{key:"getAreaPath",value:function getAreaPath(

props){
var xScale=props.scale.x;
var yScale=props.scale.y;
var areaFunction=d3Shape.area().
curve(d3Shape[this.toNewName(props.interpolation)]).
x(function(data){return xScale(data.x1||data.x);}).
y1(function(data){return yScale(data.y1||data.y);}).
y0(function(data){return yScale(data.y0);});
return areaFunction(props.data);
}},{key:"getLinePath",value:function getLinePath(

props){
var xScale=props.scale.x;
var yScale=props.scale.y;
var lineFunction=d3Shape.line().
curve(d3Shape[this.toNewName(props.interpolation)]).
x(function(data){return xScale(data.x1||data.x);}).
y(function(data){return yScale(data.y1);});
return lineFunction(props.data);
}},{key:"renderArea",value:function renderArea(


path,style,events){
var areaStroke=style.stroke?"none":style.fill;
var areaStyle=(0,_assign3.default)({},style,{stroke:areaStroke});var _props=
this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
return(
_react2.default.createElement("path",_extends({
key:"area",
style:areaStyle,
shapeRendering:shapeRendering||"auto",
role:role||"presentation",
d:path,
className:className},
events)));


}},{key:"renderLine",value:function renderLine(


path,style,events){
if(!style.stroke||style.stroke==="none"||style.stroke==="transparent"){
return undefined;
}var _props2=
this.props,role=_props2.role,shapeRendering=_props2.shapeRendering,className=_props2.className;
var lineStyle=(0,_assign3.default)({},style,{fill:"none"});
return(
_react2.default.createElement("path",_extends({
key:"area-stroke",
shapeRendering:shapeRendering||"auto",
style:lineStyle,
role:role||"presentation",
d:path,
className:className},
events)));


}},{key:"render",value:function render()

{var _props3=
this.props,events=_props3.events,groupComponent=_props3.groupComponent,data=_props3.data,active=_props3.active;
var style=_helpers2.default.evaluateStyle((0,_assign3.default)({fill:"black"},this.props.style),data,active);
var area=this.renderArea(this.getAreaPath(this.props),style,events);
var line=this.renderLine(this.getLinePath(this.props),style,events);
return _react2.default.cloneElement(groupComponent,{},area,line);
}}]);return Area;}(_react2.default.Component);Area.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,data:_react.PropTypes.array,events:_react.PropTypes.object,groupComponent:_react.PropTypes.element,interpolation:_react.PropTypes.string,shapeRendering:_react.PropTypes.string,role:_react.PropTypes.string,scale:_react.PropTypes.object,style:_react.PropTypes.object};exports.default=Area;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/area.js
// module id = 1262
// module chunks = 0 1